<div class="modal fade" id="modalRecarga" tabindex="-1" aria-labelledby="modalRecargaLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title fs-5" id="exampleModalLabel">Recarga</h3>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="fecharModal()"></button>
            </div>
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="recarga-tab" data-bs-toggle="tab"
                        data-bs-target="#recarga-tab-pane" type="button" role="tab"
                        aria-controls="recarga-tab-pane" aria-selected="true">
                        <div class="icone">
                            <span class="material-symbols-outlined">
                                receipt_long
                            </span>
                        </div>
                        <span class="texto">Valor da recarga</span>
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="pagamento-tab" data-bs-toggle="tab"
                        data-bs-target="#pagamento-tab-pane" type="button" role="tab"
                        aria-controls="pagamento-tab-pane" aria-selected="false" disabled>
                        <div class="icone">
                            <span class="material-symbols-outlined">
                                attach_money
                            </span>
                        </div>
                        <span class="texto">Pagamento</span>
                    </button>
                </li>
            </ul>
            <div class="modal-body">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="recarga-tab-pane" role="tabpanel"
                        aria-labelledby="recarga-tab" tabindex="0">
                        <div>
                            <label class="form-label">Quantos contatos você deseja adquirir?</label>
                            <select (change)="onChangePlanoRecarga($event)" class="form-select" id="selecionarNumeroContatosDownload" [(ngModel)]="idPlanoRecargaSelecionado">
                                <option value="0" selected>Selecione o número de pontos</option>
                                <option *ngFor="let plano of planosRecarga" value="{{plano.idPlanoPrePago}}">{{plano.nome}}</option>
                            </select>
                        </div>

                        <ul class="space-y-4 col-span-12 mt-4">
                            <li class="flex items-center justify-between">
                                <span class="font-normal">Seu saldo é</span>
                                <span>{{Util.formatarNumeroMilharesCentenas(saldo?.quantidade ?? 0)}} pts</span>
                            </li>
                            <li class="flex items-center justify-between" id="saldoCreditos" *ngIf="idPlanoRecargaSelecionado && idPlanoRecargaSelecionado > 0">
                                <span class="font-normal">Você ficará com</span>
                                <span>{{Util.formatarNumeroMilharesCentenas(saldoAtualizado)}} pts</span>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-pane fade" id="pagamento-tab-pane" role="tabpanel"
                        aria-labelledby="pagamento-tab" tabindex="0">Pagamento</div>
                </div>
            </div>
            <div class="modal-footer flex items-center justify-end gap-6">
                <button type="button" class="btn btn-secondary" data-bs-toggle="modal"
                    data-bs-target="#modalGerarListaContatos" data-bs-dismiss="modal">Anterior</button>
                <button type="button" class="btn btn-primary" (click)="navegarParaRecargas($event)">Próximo</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="fecharModal()">Cancelar</button>
            </div>
        </div>
    </div>
</div>